import Icon from 'components/Icon'
import { IconButton } from 'components/IconButton'
import { observer } from 'mobx-react'
import React from 'react'
import cx from 'classnames'
import styles from './JobScopeInventoryItem.sass'
import { JobScopeInventoryItem } from '../../UpdateJobScopeViewModel'

export default observer(function JobScopeInventoryItem({
  item,
  dataTestId,
}: {
  item: JobScopeInventoryItem
  dataTestId: string
}) {
  return (
    <div className={styles.itemContainer} data-test="job-scope-update-item">
      <IconButton
        className={styles.removeItemButton}
        onClick={() => item.toggle()}
        dataTest={`job-scope-update-inventory-remove-button-${dataTestId}`}
      >
        <Icon name="close" size={24} />
      </IconButton>

      <div className={styles.textContainer}>
        <div className={styles.title}>{item.name}</div>
        <div className={styles.description}>{item.description}</div>
      </div>

      <div
        className={styles.currentQuantityContainer}
        data-test={`job-scope-update-inventory-current-quantity-${dataTestId}`}
      >
        {item.currentQuantity}
      </div>

      <div className={styles.itemQuantityContainer}>
        <IconButton>
          <Icon name="subtract" size={16} onClick={item.decrementQuantity} />
        </IconButton>

        <input
          key="quantity"
          type="number"
          min="1"
          className={cx(styles.input, styles.itemQuantity)}
          value={item.newQuantity}
          onChange={(e) => item.setQuantity(e.target.value)}
          data-test={`job-scope-update-inventory-quantity-${dataTestId}`}
        />

        <IconButton onClick={item.incrementQuantity}>
          <Icon name="add" size={16} />
        </IconButton>
      </div>
    </div>
  )
})
